
import React from 'react' 
import Navbar from '../../@shared/navigations/default';
import { CategoryFilters } from './filtering';
import { CategoryBanner } from './banner';
import { CategoryGridView } from './viewgrid';
import { CategoryListView } from './viewlist';

 
const CategoryPage = () => {

    return (
        <React.Fragment>
            <title>Category</title>
            <Navbar /> 
            <div className='category' id="category">
                <CategoryFilters />
                <CategoryBanner /> 
                <CategoryGridView />
                <CategoryListView />
            </div>
        </React.Fragment>
    )
}  

export default CategoryPage;



